import { Box, Grid } from "@mui/material";
import { styled } from "@mui/material";

export const ZShapeContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1440px",
  display: "flex",
  padding: "2rem 1rem",
  flexDirection: "column",
  alignItems: "center",
  gap: "2rem",
  alignSelf: "stretch",
  background: theme.palette.common.corporateColors.primary.midNightBlue,

  [theme.breakpoints.up("md")]: { padding: "3rem 2rem", height: "35rem" },

  [theme.breakpoints.up("lg")]: {
    height: "43.75rem",
  },
}));

export const ZShapeImageWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  position: "relative",
  height: "224px",
  borderRadius: "24px",
  overflow: "hidden",

  [theme.breakpoints.up("md")]: {
    height: "320px",
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    height: "384px",
    width: "100%",
  },

  img: {
    objectFit: "cover !important",
    objectPosition: "center",
  },
}));

export const ZShapeRightColumn = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "1.5rem",
  width: "22.375rem",
  background: theme.palette.common.corporateColors.primary.midNightBlue,

  [theme.breakpoints.up("md")]: {
    height: "29.5rem",
  },

  [theme.breakpoints.up("lg")]: {
    height: "42.5rem",
  },
}));
